import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useAuth } from "@/contexts/AuthContext";
import { db } from "@/integrations/firebase/firestore";
import { logError } from "@/shared/services/ErrorReporting";

export const useTenantMembers = () => {
  const { authUser } = useAuth();
  const [memberEmails, setMemberEmails] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!authUser?.email) {
      setMemberEmails([]);
      setError(null);
      setIsLoading(false);
      return;
    }

    let isMounted = true;
    setIsLoading(true);

    const tenantsQuery = query(
      collection(db, "tenants"),
      where("active_user_emails", "array-contains", authUser.email),
    );

    getDocs(tenantsQuery)
      .then((snapshot) => {
        if (!isMounted) return;
        const first = snapshot.docs[0];
        const emails: string[] = first?.data().active_user_emails ?? [];
        setMemberEmails(emails);
        setError(null);
        setIsLoading(false);
      })
      .catch((err: Error) => {
        if (!isMounted) return;
        logError(err);
        setMemberEmails([]);
        setError(err);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [authUser?.email]);

  return { memberEmails, isLoading, error };
};
